import { Component, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-auto-open-menu',
  templateUrl: './auto-open-menu.component.html',
  styleUrls: ['./auto-open-menu.component.scss'],
})
export class AutoOpenMenuComponent implements OnDestroy {
  isOpen = false;
  private timedOutCloser: ReturnType<typeof setTimeout> | null = null;

  constructor() { }

  mouseEnter() {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
      this.timedOutCloser = null;
    }
    this.isOpen = true;
  }

  mouseLeave() {
    this.timedOutCloser = setTimeout(() => {
      this.isOpen = false;
      this.timedOutCloser = null;
    }, 150);
  }

  ngOnDestroy(): void {
    if (this.timedOutCloser) {
      clearTimeout(this.timedOutCloser);
    }
  }

}
